var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.837 15.75a8.153 8.153 0 0 0 1.913-5.25 8.25 8.25 0 1 0-8.25 8.25c1.92 0 3.78-.676 5.25-1.913l5.692 5.663 1.058-1.058-5.663-5.692zm-6.337 1.5a6.75 6.75 0 1 1 0-13.5 6.75 6.75 0 0 1 0 13.5z",
    fill: "#4A4A4A",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/explore_icon.31c10ef8022e0ade38176e0c7e41e7e8.svg";
export { ForwardRef as ReactComponent };